import React, { Component } from 'react'
import Logic from './logic'

import TariffSubscribeModal from 'containers/TariffSubscribeModal'
import Modal from 'components/ModalExtended'
import TariffDetails from 'components/TariffDetails'
import Loading from 'components/Loading'
import { sendGevent, csObjectFromUnderscore } from 'utils'

@Logic
export default class HomeWrapper extends Component {
  state = {
    moreOpen: false,
    adhesionOpen: false,
    adhesionTariff: null,
    priceListTimeCycle: null,
  }

  /** Detail modal buttons */
  detailsButtons = [
    {
      label: 'fechar',
      color: '#006736',
      primary: false,
      click: () => this.toggleMoreModal(null),
    },
    {
      label: 'aderir',
      primary: true,
      click: () => this.switchToAdhere(),
    },
  ]

  constructor() {
    super()

    window.addEventListener('tarifadhere', (e) => {
      this.toggleAdhereModal(csObjectFromUnderscore(e.detail))
    })

    window.addEventListener('tarifinfo', (e) => {
      this.toggleMoreModal(csObjectFromUnderscore(e.detail))
    })
  }

  switchToAdhere = () => {
    this.setState({
      moreOpen: false,
      detailsTariff: null,
      adhesionOpen: true,
    })
  }

  /**
   * Opens/Closes KnowMore modal
   */
  toggleMoreModal = (tariff) => {
    sendGevent('home', 'Saber mais', 'Saber mais sobre um tarifário')
    tariff && this.actions.fetchTariffInfo(tariff.id)
    const tariffPriceListTimeCycle = tariff && tariff.priceListTimeCycle
    this.setState({
      moreOpen: !this.state.moreOpen,
      detailsTariff: tariff,
      adhesionTariff: tariff,
      priceListTimeCycle: tariffPriceListTimeCycle || null,
    })
  }

  /**
   * Opens/Closes aderir modal
   */
  toggleAdhereModal = (tariff) => {
    sendGevent('home', 'Intenção Aderir', 'Intenção de aderir a um tarifário')
    this.setState({
      adhesionTariff: tariff,
      adhesionOpen: !this.state.adhesionOpen,
    })
  }

  render() {
    const { loading, simulation, tariffInfo, userProfile } = this.props

    return (
      <div>
        {/* Know More Modal */}
        {this.state.detailsTariff && this.state.moreOpen && (
          <Modal
            title='detalhes do tarifário'
            toggle={this.state.moreOpen}
            onClick={this.toggleMoreModal}
            custom={false}
            buttons={this.detailsButtons}>
            {!loading && (
              <TariffDetails
                tariff={tariffInfo}
                resultTariff={this.state.detailsTariff}
                priceListTimeCycle={this.state.priceListTimeCycle}
              />
            )}
            {loading && <Loading />}
          </Modal>
        )}

        {/* Aderir Modal */}
        {this.state.adhesionTariff && this.state.adhesionOpen && (
          <TariffSubscribeModal
            userProfile={userProfile}
            tariff={this.state.adhesionTariff}
            changeTariff={this.toggleAdhereModal}
            simulation={simulation}
            isHome={true}
          />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/HomeWrapper/index.js